module.exports = __webpack_public_path__ + "static/media/Alcoholtest-icon.fb3a56c2.jpg";